export default {"src":"/_next/static/media/0x2ba592f78db6436527729929aaf6c908497cb200.f246cf38.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};